import React from 'react';
import { MultiButtonModal } from 'web-ui-components/lib/layout/content';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import content from '../../payees/components/AddNewPayeeLandingPage/index.content';

export function DuplicatePayeeModal({ handleOK, handleClose }) {
	return (
		<MultiButtonModal
			buttons={[<NavigationButton.Primary labelText="OK" onClick={handleOK} />]}
			isOpen={true}
			onClose={handleClose}
		>
			<p>{content.duplicatePayeeErrorMessage}</p>
		</MultiButtonModal>
	);
}
